import { usersList } from './users';

function managerName(headUserId) {
  const u = usersList.find((x) => x.id === headUserId);
  return u ? u.displayName : '—';
}

export const departmentsList = Array.from({ length: 8 }, (_, i) => ({
  id: `dept-${i}`,
  name: ['Sales', 'Engineering', 'HR', 'Finance', 'Operations', 'Legal', 'Marketing', 'Support'][i],
  headUserId: `usr-${2100 + (i % 5)}`,
  managerName: managerName(`usr-${2100 + (i % 5)}`),
  memberCount: 12 + i * 6,
  defaultDurationMin: [30, 45, 60, 60, 30, 45, 60, 30][i],
  reminderPolicy: i % 2 === 0 ? '15m + 1h email' : '30m Teams',
  status: 'active',
  archived: false,
  defaultRoomPolicy: i % 2 === 0 ? 'auto_book' : 'request_only',
  parentDepartmentId: i > 2 && i < 6 ? 'dept-1' : null,
}));

export const departmentDetailTemplate = {
  description: 'Revenue-facing teams across GCC.',
  costCenter: 'CC-4401',
  scimGroupId: 'grp_sales_gcc',
  bookingDefaults: {
    defaultDurationMin: 60,
    defaultProvider: 'Teams',
    bufferBeforeMin: 5,
    bufferAfterMin: 10,
  },
  reminderDefaults: {
    minutesBefore: 15,
    channels: { email: true, teams: true, whatsapp: false },
    secondaryEnabled: true,
    secondaryMinutesBefore: 60,
  },
  approvalPolicy: {
    momApprovalRequired: true,
    approverRole: 'tenant_admin',
    approvalTimeoutDays: 5,
  },
  memberUserIds: ['usr-2000', 'usr-2001', 'usr-2002'],
};

export const departmentDetail = {
  ...departmentsList[0],
  ...departmentDetailTemplate,
  managerName: departmentsList[0].managerName,
};

const DEPT_NAMES = departmentsList.map((d) => d.name);

export const orgMappingsSeed = Array.from({ length: 12 }, (_, i) => {
  const provider = i % 2 === 0 ? 'M365' : 'Google';
  const suggested = DEPT_NAMES[i % DEPT_NAMES.length];
  const mapped = i % 5 === 0 ? null : DEPT_NAMES[(i + 2) % DEPT_NAMES.length];
  let status = 'mapped';
  if (!mapped) status = 'unmapped';
  else if (i % 7 === 0) status = 'conflict';
  return {
    id: `omap-${i}`,
    externalGroup: `GG-Dept-${String(i + 1).padStart(2, '0')} / ${provider === 'M365' ? 'Azure AD' : 'Workspace'}`,
    provider,
    suggestedDepartment: suggested,
    finalDepartmentId: mapped ? departmentsList.find((d) => d.name === mapped)?.id || `dept-${i % 8}` : null,
    finalDepartmentName: mapped,
    status,
    source: provider === 'M365' ? 'azure_ad' : 'google_workspace',
    lastSyncAt: new Date(Date.now() - i * 3600000).toISOString(),
  };
});

export const orgMappings = orgMappingsSeed.map((r, idx) => ({
  id: r.id,
  source: r.source,
  externalGroup: r.externalGroup,
  internalDepartmentId: r.finalDepartmentId || departmentsList[idx % departmentsList.length].id,
  syncEnabled: r.status !== 'unmapped',
  lastSyncAt: r.lastSyncAt,
}));
